import itemsMain from '@/nav/items-main'
import itemsBottom from '@/nav/items-bottom'
import itemsAdmin from '@/nav/items-admin';
import itemsTech from '@/nav/items-tech';
import itemsDemo from '@/nav/_nav';
import itemsAgent from '@/nav/items-agent';
import itemsAgency from '@/nav/items-agency';
import itemsManager from '@/nav/items-manager';
import itemsBuh from '@/nav/items-buh';
import itemsWebmaster from '@/nav/items-webm';
import itemsJur from '@/nav/items-jur';

let _items = [];
let _itemsp = [
    {
        name: 'Админ',
        url: '/admin',
        icon: 'icon-puzzle',
        children: itemsAdmin.items
    },
    {
        name: 'Техотдел',
        url: '/tech',
        icon: 'icon-puzzle',
        children: itemsTech.items,
        badge: {
            variant: 'danger',
            text: 'NEW'
        }
    },
    {
        name: 'Бухгалтер',
        url: '/buh',
        icon: 'icon-puzzle',
        children: itemsBuh.items
    },
    {
        name: 'Менеджер',
        url: '/manager',
        icon: 'icon-puzzle',
        children: itemsManager.items
    },
    {
        name: 'Агентство',
        url: '/agency',
        icon: 'icon-puzzle',
        children: itemsAgency.items
    },
    {
        name: 'Агент',
        url: '/agent',
        icon: 'icon-puzzle',
        children: itemsAgent.items,
        badge: {
            variant: 'danger',
            text: 'NEW'
        }
    },
    {
        name: 'Вебмастер',
        url: '/webmaster',
        icon: 'icon-puzzle',
        children: itemsWebmaster.items
    },
    {
        name: 'Юрист',
        url: '/jurist',
        icon: 'icon-puzzle',
        children: itemsJur.items
    },
];

Array.prototype.push.apply(_items, itemsMain.items);
Array.prototype.push.apply(_items, itemsAdmin);
Array.prototype.push.apply(_items, _itemsp);
Array.prototype.push.apply(_items, itemsBottom.items);

export default {
    items: _items
}
